<template>
    <div class="">
        <Main></Main>
    </div>
</template>
<script type="text/javascript">
import Main from '@/components/dashboard_page/sub_components/main_dashboard.vue'

export default {
    components: {
        Main
    }
}

</script>
<style type="text/css" scoped>
.dashboard_page_div {
    padding: 30px;
    width: 1170px;
    margin: auto;
    display: flex;
}
</style>
